/**
 * Loader management and progress tracking
 */

export class LoaderManager {
    constructor() {
        this._showProgress = false;
    }

    // Show loading state
    showLoading(show) {
        const loader = document.getElementById('loader');
        if (loader) loader.style.display = show ? 'block' : 'none';
        try {
            const body = document.body;
            if (body) {
                if (show) body.classList.add('no-scroll');
                else body.classList.remove('no-scroll');
            }
        } catch(_) { /* noop */ }
    }

    updateLoaderProgress(percent, label) {
        if (!this._showProgress) return;
        try {
            const meter = document.querySelector('.loader-progress-number');
            const caption = document.querySelector('.loader-progress-caption');
            if (typeof percent === 'number' && meter) {
                meter.textContent = `${Math.max(0, Math.min(100, percent))}%`;
            }
            if (label && caption) caption.textContent = label;
        } catch (_) { /* noop */ }
    }

    toggleLoaderProgress(show) {
        try {
            const block = document.querySelector('.loader-progress');
            if (block) block.style.display = show ? 'block' : 'none';
        } catch(_) { /* noop */ }
    }

    // ✅ CRITICAL: DO NOT hide loader here - loader is controlled by ComponentLoadingStatus system
    // The loader will be hidden by checkIfReady() in _loader-readiness.html when ALL components are ready
    // This function is kept for backward compatibility but does nothing to prevent premature hiding
    attemptHideCriticalLoader(appReady, pageLoaded, debugMode) {
        // ❌ ABSOLUTELY FORBIDDEN: Do NOT hide loader without checking ComponentLoadingStatus
        // The loader will be hidden by checkIfReady() in _loader-readiness.html when ALL components are ready
        if (window.HyperLog && debugMode === '1') {
            if (false) window.HyperLog.debug('[MainApp] attemptHideCriticalLoader called but ignored - using ComponentLoadingStatus system', {
                appReady: appReady,
                pageLoaded: pageLoaded
            });
        }
    }

    // ✅ CRITICAL: Safety timeout DISABLED - loader is controlled by ComponentLoadingStatus system
    // The loader in _loader-readiness.html has its own 60s safety timeout that checks ComponentLoadingStatus
    // This old timeout was causing premature spinner hiding before /api/files/ completed
    setupSafetyTimeout(debugMode) {
        // ❌ ABSOLUTELY FORBIDDEN: Do NOT hide loader without checking ComponentLoadingStatus
        // The loader will be hidden by checkIfReady() in _loader-readiness.html when ALL components are ready
    }
}

